var initCopyLink = function initCopyLink() {
  var copyButtons = document.querySelectorAll('.copy-link');
  if (!copyButtons) return;
  var showTooltip = function showTooltip(button, message) {
    var tooltip = button.querySelector('.tooltip');
    if (!tooltip) {
      tooltip = document.createElement('span');
      tooltip.className = 'tooltip';
      button.appendChild(tooltip);
    }
    tooltip.textContent = message;
    tooltip.classList.add('visible');
    setTimeout(function () {
      tooltip.classList.remove('visible');
    }, 2000);
  };
  copyButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      var url = button.getAttribute('data-url');
      if (url) {
        navigator.clipboard.writeText(url).then(function () {
          showTooltip(button, 'Copied!');
        })["catch"](function (error) {
          console.error('Failed to copy text:', error);
          showTooltip(button, 'Error copying');
        });
      } else {
        console.error('No URL found to copy!');
        showTooltip(button, 'No URL');
      }
    });
  });
};
export { initCopyLink };